export enum SlideHeightControlMode {
  AUTO_STRETCH = 'auto',
  NONE = 'none',
}
